import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import AllocationSettings from '../../../components/AllocationSettings';
import NotificationSettings from '../../../components/NotificationSettings';
import OrderFilterSettings from '../../../components/OrderFilterSettings';
import OrderProcessingSettings from '../../../components/OrderProcessingSettings';
import PricingSettings from '../../../components/PricingSettings';
import RoutesSettings from '../../../components/RoutesSettings';
import ServicePointSettings from '../../../components/ServicePointSettings';
import TransferSettings from '../../../components/TransferSettings';
import VendorSettings from '../../../components/VendorSettings';
import ShippingMethodSettings from '../../../components/ShippingMethodSettings';
import PaymentMethodSettings from '../../../components/PaymentMethodSettings';
import ChannelInfoSettings from '../../../components/ChannelInfoSettings';
import EmailBCCSettings from '../../../components/EmailBCCSettings';
import OrderTagsSettings from '../../../components/OrderTagsSettings';
import PosReceiptInfoSettings from '../../../components/PosReceiptInfoSettings';
import SettingsHeader from '../../../components/SettingsHeader';
import ShipmentCredentialSettings from '../../../components/ShipmentCredentialSettings';
import PaymentCredentialSettings from '../../../components/PaymentCredentialSettings';
import translations from './translations';

const GeneralSettings = () => {
  const intl = useIntl();

  return (
    <>
      <ChannelInfoSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.pos)} />
      <PosReceiptInfoSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.invoicing)} />
      <PricingSettings pathID="tenant" />
      <VendorSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.messaging)} />
      <NotificationSettings pathID="tenant" />
      <EmailBCCSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.shipping)} />
      <ShipmentCredentialSettings pathID="tenant" />
      <ShippingMethodSettings pathID="tenant" />
      <ServicePointSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.payment)} />
      <PaymentCredentialSettings pathID="tenant" />
      <PaymentMethodSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.orders)} />
      <OrderProcessingSettings pathID="tenant" />
      <OrderTagsSettings pathID="tenant" />
      <OrderFilterSettings pathID="tenant" />

      <SettingsHeader title={intl.formatMessage(translations.settings.wms)} />
      <AllocationSettings pathID="tenant" />
      <RoutesSettings pathID="tenant" />
      <TransferSettings pathID="tenant" />
    </>
  );
};

export default GeneralSettings;
